// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-066a4ec2] .ant-input-search-button {\n  padding-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
